import React from 'react';
import styled from 'styled-components';
import { DirtyChangeIcon } from "./DitryChangeIcon";
import {lbl} from "../../../utils/intl";

const TabContainer = styled.div`
    display: flex;
    border-bottom: 1px solid #ccc;
`;

const TabButton = styled.button`
  display: flex;
  align-items: center;
  padding: 10px 20px;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 16px;
  outline: none;
  border-bottom: ${({ isActive }) => isActive ? '2px solid #0183D5' : 'none'};
  color: ${({ isActive }) => isActive ? '#0183D5' : '#333'};

  .icon-alert {
    margin-right: 10px;
    color: red;
  }

  .tooltip-text {
    display: inline-block;
    visibility: hidden;
    width: 120px;
    background-color: black;
    color: white;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;
    position: absolute;
    z-index: 1;
    bottom: 100%;
    left: 50%;
    margin-left: -60px;
    opacity: 0;
    transition: opacity 0.3s;
  }

  &:hover .tooltip-text {
    visibility: visible;
    opacity: 1;
  }
`;

const TaxRegionsTab = (props) => (
  <TabContainer>
    {props.addedRegions.map(r => (
      <TabButton
        isActive={r.taxRegion === props.activeRegion}
        onClick={() => props.onClickTaxRegion({value: r.taxRegion})}
        dirty={r.dirty}
      >
        {r.dirty && <DirtyChangeIcon message={lbl('product.create.dirtyChange')}/>}
        {r.taxRegion}
      </TabButton>
    ))}
  </TabContainer>
)

export default TaxRegionsTab;

